import axios from "axios";
import { LANG, LOCALES } from "@/lib/i18n";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Lang": LANG },
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 402 && err.response.data?.detail?.code === "upgrade_required" && (orig?.method || "get").toLowerCase() !== "get") {
      window.dispatchEvent(new CustomEvent("upgrade-required", { detail: err.response.data.detail }));
    }
    if (err.response?.status === 401 && orig && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(err, fallback = "Bir şeyler ters gitti. Lütfen tekrar deneyin.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (detail?.code === "upgrade_required" || detail?.code === "revshare_required" || detail?.code === "credits_required") return detail.message;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORY_LABELS = { freelance: "Freelance", affiliate: "Affiliate", bounty: "Bounty", survey: "Anket", airdrop: "Airdrop" };
export const RISK_LABELS = { low: "Düşük Risk", medium: "Orta Risk", high: "Yüksek Risk" };
export const STATUS_LABELS = {
  new: "Yeni", interested: "İlgileniyorum", applied: "Başvuruldu", in_progress: "Süreçte",
  won: "Kazanıldı", lost: "Kaybedildi", dismissed: "Geçildi",
};

export const TIER_RANK = { free: 0, pro: 1, pro_auto: 2, ultra: 3, ultrax: 4, ultraxl: 5, ultraxxl: 6 };
export const TIER_LABELS = { free: "Ücretsiz", pro: "Pro", pro_auto: "Pro Otomasyon", ultra: "Ultra", ultrax: "UltraX", ultraxl: "UltraXL", ultraxxl: "UltraXXL" };
export const PRICE_USD = { pro: { month: 20, year: 200 }, pro_auto: { month: 30, year: 300 }, ultra: { month: 50, year: 500 }, ultrax: { month: 75, year: 750 }, ultraxl: { month: 125, year: 1200 }, ultraxxl: { month: 175, year: 1470 } };

export function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(LOCALES[LANG].replace("_", "-"), { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
